<form [formGroup]="form" class="mt-4 formPhone w-100 fadeIn">
  <p class="text-center">
    {{ 'k002464' | translate }}
    <!-- Token: Let’s validate your account with a SMS code. Enter a valid mobile phone and click continue button. -->
  </p>
  <div class="contentinput">
    <mat-form-field class="mr-2 w-100">
      <input
        matInput
        name="codephone"
        maxlength="4"
        formControlName="codephone"
        class="inp-item text-right"
        value="{{ codePhone }}"
        (keyup)="keyupcodephone($event)"
      />
      <!-- Token: Phone -->
    </mat-form-field>
    <mat-form-field class="w-100">
      <input
        matInput
        type="number"
        pattern="\d*"
        maxlength="18"
        name="phone"
        placeholder="{{ 'k000081' | translate }}"
        formControlName="phone"
        class="inp-item"
        (keyup)="keyupphone()"
      />
      <!-- Token: Telephone -->
    </mat-form-field>
  </div>
  <button
    type="button"
    id="btoSMSnext"
    class="buttonPortal lg my-4"
    mat-raised-button
    color="blue"
    [disabled]="form.invalid"
    (click)="goNext($event)"
  >
    <span>{{ 'k000226' | translate }}</span>
    <!-- Token: Continuar -->
  </button>
</form>
